import { SVGProps, Ref, forwardRef } from 'react';

export const ChevronGroup1FilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M6.85 14c0-.681.005-.982.04-1.247a4.53 4.53 0 0 1 2.68-3.551c.238-.105.554-.19 1.18-.37V7.168c-.626-.18-.942-.265-1.18-.37a4.53 4.53 0 0 1-2.68-3.551C6.855 2.982 6.85 2.68 6.85 2h-1.6c0 .657.003 1.076.054 1.46A6.13 6.13 0 0 0 8.396 8a6.13 6.13 0 0 0-3.09 4.54c-.052.384-.055.803-.055 1.46z"
                fill="currentColor"
            />
        </g>
    </svg>
));
ChevronGroup1FilledSize16Glyph.displayName = 'ChevronGroup1FilledSize16Glyph';
